import { SpreadsheetColumnSettingsDef } from "@components/spreadsheet/SpreadsheetColumnSettings";

/**
 * localStorage key used to persist the user's hidden-column preferences for
 * the JE drawer spreadsheet. Intentionally not workspace-scoped — column
 * visibility is a UI preference that should survive workspace switches.
 */
export const JE_SPREADSHEET_COLUMNS_STORAGE_KEY =
    "je-spreadsheet-hidden-columns";

/**
 * Canonical ordered list of JE spreadsheet columns.
 *
 * - `immutable` columns are always visible and cannot be hidden.
 * - `gridFr` is the proportional width unit used to build `gridTemplateColumns`.
 * - The `classIds` column is gated by `isClassesActivated` at the call site —
 *   when classes are disabled the column is simply omitted from the list passed
 *   to the spreadsheet, so it never appears in the popover either.
 */
interface JeColumnMeta extends SpreadsheetColumnSettingsDef {
    gridFr: number;
}

export const JE_COLUMNS: readonly JeColumnMeta[] = [
    { field: "", label: "", immutable: true, gridFr: 40 },
    { field: "accountId", label: "Account", immutable: true, gridFr: 429 },
    {
        field: "counterpartyId",
        label: "Counterparty",
        immutable: false,
        gridFr: 150,
    },
    { field: "classIds", label: "Class", immutable: false, gridFr: 60 },
    { field: "debitAmount", label: "Debit", immutable: true, gridFr: 122 },
    { field: "creditAmount", label: "Credit", immutable: true, gridFr: 122 },
    {
        field: "excludeFrom1099",
        label: "Exclude from 1099",
        immutable: false,
        gridFr: 130,
    },
    {
        field: "description",
        label: "Description",
        immutable: false,
        gridFr: 434,
    },
];

/**
 * Builds a CSS `grid-template-columns` string from the provided column metas.
 * Each column contributes its `gridFr` value as a fractional unit.
 */
export function buildJeGridTemplateColumns(
    columns: readonly JeColumnMeta[],
): string {
    return columns.map((c) => `${c.gridFr}fr`).join(" ");
}
